import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FormattedMessage } from "react-intl";
import { hp } from "../../utils";

import LoginMiddle from '../../assets/img/auth/login.png';
import SignupMiddle from '../../assets/img/auth/signup.svg';
import company from '../../assets/img/company.svg';


const AuthAside = props => {
    const screen = window.location.pathname.split('/')[2];

    const accountId = props._utils.inv_accountId;
    const [person, setPerson] = useState({});
    const [account, setAccount] = useState({});
    const [gotAccount, setGotAccount] = useState(false);

    
    if (screen === 'invitation' && accountId && !gotAccount) {
        const token = window.location.pathname.split('/')[3];
        setGotAccount(true);
        axios({
            method: 'GET',
            url: `${hp.getApiBaseUrl()}/accounts/${accountId}/invitations/${token}/accounts`,
            json: false
        }).then((res) => {
            if (res.data.statusCode === 200) {
                setAccount(res.data.data);
                props.setInvCookie('inv_account', (res.data.data));
                axios({
                    method: 'GET',
                    url: `${hp.getApiBaseUrl()}/accounts/${accountId}/invitations/${token}/inviters`,
                    json: false
                }).then((res) => {
                    if (res.data.statusCode === 200) {
                        setPerson(res.data.data);
                        props.setInvCookie('inv_person', (res.data.data));
                    }
                });
            }
        });
    }

    useEffect(() => {
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="authWrapper__FormCardLeft">
            {['signin', 'reset', 'signup', 'create-account']['includes'](screen) && (
                <div>
                    <img src={LoginMiddle} alt="Esoko" style={{ width: '65%', marginLeft: '10%' }} className="animated fadeIn delay-1s" />
                    <div className="h1 animated fadeIn delay-1s">
                        <FormattedMessage id="Auth.Text1" defaultMessage="Collect data, profile people and deliver digital services" />
                    </div>
                    <div className="h2 animated fadeIn delay-1s">
                        {/* DATA COLLECTION &nbsp;|&nbsp; ANALYTICS &nbsp;|&nbsp; BULK MESSAGING */}
                        <FormattedMessage id="Auth.Text2" defaultMessage="COMMUNITY MANAGEMENT PLATFORM" />
                    </div>
                </div>
            )}

            {['signups', 'create-accounts']['includes'](screen) && (
                <div>
                    <img src={SignupMiddle} alt="Esoko" style={{ width: '65%', marginLeft: '10%' }} className="animated fadeIn delay-1s" />
                    <div className="h1 animated fadeIn delay-1s">
                        Collect data, send messages and <br /> build reports easily.
                    </div>
                </div>
            )}

            {['invitation']['includes'](screen) && (person.email && account.name) && (
                <div id="invitation__aside" className="animated fadeIn delay-1s">
                    <div className="p">
                        <FormattedMessage id="kkk" defaultMessage="You have been invited to join an organization on Esoko." />
                    </div>
                    <div className="logo">
                        <img src={company} alt={account.name} />
                    </div>
                    <p className="">
                        <b>{account.name}</b>
                    </p>
                    <p>
                        <FormattedMessage id="InvitedBy" defaultMessage="Invited by" />: <b>{person.firstName} {person.lastName} ({person.email})</b>
                    </p>
                </div>
            )}
        </div>
    )
};

export default AuthAside;